const listAttributes = ['subject', 'topicId', 'label', 'topicGroup'] as const;

const getAttributes = [...listAttributes, 'exams'] as const;

const searchAttributes = ['label'] as const;

const updateAttributes = ['label'] as const;

export const LegacyTopicAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Search: searchAttributes,
  Update: updateAttributes,
};
